"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userRoleNiceName = exports.EhsMaintenanceRoles = exports.EhsSiteRoles = exports.EUserRoles = void 0;
var EUserRoles;
(function (EUserRoles) {
    EUserRoles["Ptw"] = "ptw";
    EUserRoles["EhsManager"] = "ehs-manager";
    EUserRoles["EhsApplicant"] = "ehs-applicant";
    EUserRoles["EhsMaintenanceManager"] = "ehs-maintenance-manager";
    EUserRoles["EhsMaintenanceBasic"] = "ehs-maintenance-basic";
    EUserRoles["EhsMaintenanceExternalCompany"] = "ehs-maintenance-company";
    EUserRoles["EhsMaintenanceExternalCompanyPlus"] = "ehs-maintenance-company-plus";
})(EUserRoles = exports.EUserRoles || (exports.EUserRoles = {}));
exports.EhsSiteRoles = [EUserRoles.EhsManager, EUserRoles.EhsApplicant];
exports.EhsMaintenanceRoles = [
    EUserRoles.EhsMaintenanceManager,
    EUserRoles.EhsMaintenanceBasic,
    EUserRoles.EhsMaintenanceExternalCompany,
    EUserRoles.EhsMaintenanceExternalCompanyPlus,
];
function userRoleNiceName(userRole) {
    switch (userRole) {
        case EUserRoles.Ptw:
            return 'PTW';
        case EUserRoles.EhsManager:
            return 'EHS Manager';
        case EUserRoles.EhsApplicant:
            return 'EHS Applicant';
        case EUserRoles.EhsMaintenanceManager:
            return 'EHS Maintenance Manager';
        case EUserRoles.EhsMaintenanceBasic:
            return 'EHS Maintenance Basic';
        case EUserRoles.EhsMaintenanceExternalCompany:
            return 'EHS Maintenance External Company';
        case EUserRoles.EhsMaintenanceExternalCompanyPlus:
            return 'EHS Maintenance External Company Plus';
        default:
            return '';
    }
}
exports.userRoleNiceName = userRoleNiceName;
